<template>
  <div id="app">
    <el-container>
      <el-aside :width="asideWidth" >
        <div style="height: 60px; line-height: 60px; font-size: 20px; display: flex; align-items: center; justify-content: center">
          <img :src="require('@/assets/logo.png')" style="width: 130px;" alt="">
          <!-- <span class="logo-title" v-show="!isCollapse">管理中心</span> -->
        </div>

        <el-menu 
    default-active="2"
    class="el-menu-vertical-demo"
    @open="handleOpen"
    @close="handleClose"
    background-color="#2289e9"
    text-color="#fff"
    active-text-color="#fff"
    :collapse-transition="true">
    <el-menu-item index="/home/Welcome">
            <i class="el-icon-s-home" style="color: #fff;"></i>
            <span slot="title" style="color: #fff;">管理首页</span>
    </el-menu-item>

      <el-submenu v-for="menu in menus" :key="menu.id" :index="menu.id" style="color:#fff ;">
        <template slot="title"  >
          <i v-if="filterData(menu.icon)" :class="filterData(menu.icon)" style="color: #fff;"></i>
          <span>{{menu.name}}</span>
        </template>
        <el-menu-item  v-for="item in menu.children" :key="item.id">
          <router-link v-if="filterData(item.path)" :to="filterData(item.path)" style="text-decoration: none;color:#fff">
            {{item.name}}
          </router-link>
        </el-menu-item>
      </el-submenu>
    </el-menu>
      </el-aside>
 
      <el-container>
        <el-header style="height: 60px;background-color:#fff; line-height: 60px; display: flex; align-items: center; box-shadow: 2px 0 6px rgba(0, 21, 41, .35);">
          <i :class="collapseIcon" @click="handleCollapse" style="font-size: 26px;color: #2289e9;"></i>
           <div class="tags_view">
              <!-- 面包屑导航栏 -->
              <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
                <el-breadcrumb-item v-for="item in Breadcrumb" :key="item.path" :to="toPath(item)" class="title">
                  {{ item.meta.title }}
                </el-breadcrumb-item>
              </el-breadcrumb>
          </div>

          <div style="flex: 1; display: flex; justify-content: flex-end; align-items: center">
            <i class="el-icon-quanping" @click="handleFullScreen" style="font-size: 25px"></i>
            <el-dropdown placement="bottom">
              <div style="display: flex; align-items: center; cursor: pointer">
                <img :src="require('@/assets/logo.png')" style="width: 30px;" alt="">
 
                <span>管理员</span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item > <router-link to="/home/EditUserInfo">编辑资料</router-link></el-dropdown-item> 
                <el-dropdown-item @click="loginOut()">退出登录</el-dropdown-item> 
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
 
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
 
<script>
// 移除无用的 Link 导入（element-ui 的 router-link 直接使用，无需单独导入）
export default {
name: 'HomeView',
data() {
  return {
    dialogFormVisible: false,
    Breadcrumb: [],
    isCollapse: false,
    asideWidth: '200px',
    collapseIcon: 'el-icon-s-fold',
    form: {
      avatar: "",
      password: "",
      nickname: "",
      age: Number,
      email: "",
      mobilePhoneNumber: "",
      sex: Number,
      id: Number,
      account: "",
      area: "",
      hobby: "",
      work: "",
      design: "",
    },
    rules: {
      nickname: [
        { required: true, message: "昵称不能为空", trigger: "blur" },
      ],
      password: [
        { required: true, message: "账号密码不能为空", trigger: "blur" },
      ],
    },

    menus:[
        {
          "id": 1,
          "path": null,
          "name": "设备管理",
          "icon": "el-icon-menu",
          "children": [
            {
              "id": 1,
              "path": "/home/DeviceInfo",
              "name": "在线设备",
              "icon":null,
              "children": null
            },
            {
              "id": 2,
              "path": "/home/RegisterManager",
              "name": "授权管理",
              "icon":null,
              "children": null
            },
            {
              "id": 3,
              "path": "/home/RegisterDevice",
              "name": "设备授权",
              "icon":null,
              "children": null
            },
            {
              "id": 4,
              "path": "/home/DeleteRegisterInfo",
              "name": "解除授权",
              "icon":null,
              "children": null
            },
            {
              "id": 5,
              "path": "/home/LanDeviceInfo",
              "name": "局域网设备",
              "icon":null,
              "children": null
            }
          ]
        },
        {
          "id": 2,
          "path": null,
          "name": "系统管理",
          "icon": "el-icon-setting",
          "children": [
            {
              "id": 1,
              "path": "/home/AddUser",
              "name": "添加用户",
              "icon":null,
              "children": null
            },
            {
              "id": 2,
              "path": "/home/UserInfo",
              "name": "用户管理",
              "icon":null,
              "children": null
            }
          ]
        },
        // 新增：软件管理 一级菜单（与设备管理、系统管理平级）
        {
          "id": 3, // id 保持唯一，延续原有编号
          "path": null,
          "name": "软件管理", // 一级菜单名称
          "icon": "el-icon-laptop", // 配套图标，符合element-ui规范
          "children": [
            // 子菜单1：软件基础管理
            {
              "id": 1,
              "path": "/home/AppManager", // 对应路由配置的路径，必须一致
              "name": "软件基础管理", // 子菜单名称
              "icon": null,
              "children": null
            },
            // 子菜单2：软件版本管理
            {
              "id": 2,
              "path": "/home/AppVersionManager", // 对应路由配置的路径，必须一致
              "name": "软件版本管理", // 子菜单名称
              "icon": null,
              "children": null
            }
          ]
        }
    ]
    }
  },
  
watch: {
  $route() {
    this.genBreadcrumb(this.$route);
  },
},
created() {
  this.genBreadcrumb(this.$route);
},
methods: {
  showUserInfo(){
    this.dialogFormVisible=true;
  },
  handleFullScreen() {
    // 完善全屏逻辑，兼容关闭全屏
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch(err => {
        console.error('进入全屏失败：', err);
      });
    } else {
      document.exitFullscreen().catch(err => {
        console.error('退出全屏失败：', err);
      });
    }
  },
  handleCollapse() {
    this.isCollapse = !this.isCollapse
    this.asideWidth = this.isCollapse ? '64px' : '200px'
    this.collapseIcon = this.isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'
  },
  filterData(data) {
    console.log(data);
    return data ? data : "";
  },
  handleOpen(key, keyPath) {
    // 补全缺失的 handleOpen 方法（避免控制台报错）
    console.log('菜单展开：', key, keyPath);
  },
  handleClose(key, keyPath) {
    // 补全缺失的 handleClose 方法（避免控制台报错）
    console.log('菜单收起：', key, keyPath);
  },
  handleSelect(key, keyPath) {
    console.log(key, keyPath);
  },	
  toPath(item) {
    console.log('path::: ', item.meta);
     // 如果路径相同，点击导航则不跳转
    if (item.path === this.$route.path) {
      return ''
    }
    // 如果是固定路由，则不跳转
    if (item.meta?.affix) { // 可选链操作，避免null报错
      return ''
    } else {
      // 跳转路由
      return item.path
    }
  },
  genBreadcrumb(route) {
    // 获取含有title属性的路由。
    let matched = route.matched.filter(
      (item) => item.meta && item.meta.title
    );
    this.Breadcrumb = matched;
  },
  // 统一退出登录方法名（模板中是 loginOut，保持一致）
  loginOut() {
    // 删除 sessionStorage 中的 token
    try {
      sessionStorage.clear();
    } catch (error) {
      console.error('清除 sessionStorage 失败：', error);
    }
    // 跳转到登录页面
    this.$router.push('/login')
  }
}
}
</script>
 
<style >
.tags_view .title {
font-size: 15px !important;
}
.el-menu--inline, .el-menu-item {
background-color: #1d79d0 !important;
}
 
.el-submenu__title {
height: 40px !important;
line-height: 40px !important;
padding: 0 25px !important;
transition: color 0s;
}
.el-menu--collapse .el-submenu__title {
padding: 0 20px !important;
}
.el-submenu__title>i:nth-child(1) {
margin-top: 2px;
}
.el-submenu__title>i.el-submenu__icon-arrow {
margin-top: -5px;
}
.el-menu-item {
min-width: 0 !important;
width: calc(100% - 10px);
margin: 5px;
height: 40px !important;
line-height: 40px !important;
border-radius: 5px;
}
.el-menu--inline>.el-menu-item {
padding-left: 50px !important;
}
.el-menu-item.is-active {
background-color: dodgerblue !important;
}
 
.el-menu-item:hover {
color: #79c1ff !important;
}
 
.el-submenu__title:hover *, .el-submenu__title:hover {
color: #05a1c8 !important;
}
 
.el-aside {
box-shadow: 2px 0 6px rgba(39, 40, 40,0.3);
background-color: #2289e9;
color: #fff;
min-height: 100vh;
transition: width .3s;
}
.el-menu--collapse .el-tooltip {
padding: 0 15px !important;
}
.logo-title {
margin-left: 5px;
font-size: 17px;
color: #fff;
transition: all .3s;
}
.el-menu {
border-right: 0;
width: 200px;
transition: all .3s;
}
</style>